import React, { useEffect, useState } from 'react';
import {
    Layout,
    Page,
    Frame,
    Card,
    DataTable,
    Spinner,
    Select,
    Text,
} from '@shopify/polaris';
import Api from '../../helpers/api';
import { useHistory } from "react-router-dom";
import Paginator from "../../components/Paginator";

const Activity = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [activities, setActivities] = useState([]);
    const [user, setUser] = useState({can_manage_on_hold: false, is_admin: false})
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(0);
    const [meta, setMeta] = useState({currentPage: 1, lastPage: 1})

    useEffect(() => {
        Api.getMe().then(response => {
            setUser(response.data.user ?? {can_manage_on_hold: false, is_admin: false});
        });
    }, []);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        setLoading(true);
        Api.getUsersForRegistry().then((response) => {
            setUsers(response.data.data);
            fetchActivities();
        }).catch(() => setLoading(false));
    };

    const fetchActivities = async (userId = 0, page = 1) => {
        setLoading(true);
        Api.getUserActivities(userId, page).then((response) => {
            setActivities(response.data.data);
            setMeta({currentPage: response.data.meta.current_page, lastPage: response.data.meta.last_page});
        }).finally(() => setLoading(false));
    };

    const handleUserFilterChange = (value) => {
        setSelectedUser(value);
        fetchActivities(value);
    };

    const showCustomer = (customerId) => () => {
        history.push(`/customers/${customerId}`);
    }

    const userOptions = [
        { label: 'All users', value: '0' },
        ...users.map(user => ({
            label: user.name,
            value: user.id.toString()
        }))
    ];

    const rows = activities.map((activity) => [
        activity.type,
        activity.customer?.full_name || 'Unknown Customer',
        activity.customer?.email || 'Unknown Email',
        new Date(activity.created_at).toLocaleString(),
        activity.customer && <button onClick={showCustomer(activity.customer_id)}>Show Customer</button>
    ]);

    return (
        <Frame>
            <Page title="Users Activity"
                backAction={{ content: 'Go back', onAction: () => history.goBack() }}
            >
                <Layout>
                    <Layout.Section>
                        {user.is_admin ? (
                            <>
                                <Card sectioned>
                                    <Select
                                        label="Filter by User"
                                        options={userOptions}
                                        onChange={handleUserFilterChange}
                                        value={selectedUser}
                                    />
                                </Card><br />
                            </>
                                ) : ''}
                        {loading ? (
                            <Card>
                                <Text variant="bodyMd" color="subdued" alignment="center">
                                    <Spinner size="large" accessibilityLabel="Loading activities" />
                                </Text>
                            </Card>
                        ) : activities.length > 0 ? (
                            <>
                                <Card>
                                    <DataTable
                                        columnContentTypes={['text', 'text', 'text', 'text']}
                                        headings={['Type', 'Customer Name', 'Customer Email', 'Timestamp', 'Actions']}
                                        rows={rows}
                                    />
                                </Card>
                                <Paginator currentPage={meta.currentPage} lastPage={meta.lastPage} show={true} callback={(page) => fetchActivities(selectedUser, page)} />
                            </>
                        ) : (
                            <Card>
                                <Text variant="bodyMd" color="subdued" alignment="center">
                                    No activities found for the selected user.
                                </Text>
                            </Card>
                        )}
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
};

export default Activity;
